module.exports = __webpack_public_path__ + "static/media/sustainableWestchester.88e99304.png";